<form [formGroup]="riskForm">
    <div class="row d-flex align-items-end">
      <div class="col-12 mb-3">
          <label for="risk_result" class="form-label">{{
            "inputs.risk_result" | translate
            }}</label>
          <ng-select formControlName="risk_result" [items]="riskStatus"
            [placeholder]="'inputs.select_option' | translate" [searchable]="true" [clearable]="false"
            [notFoundText]="'tables.no_results' | translate">
            <ng-template ng-label-tmp let-item="item">
              {{ "inputs." + item | translate }}
            </ng-template>
            <ng-template ng-option-tmp let-item="item">
              {{ "inputs." + item | translate }}
            </ng-template>
          </ng-select>
      </div>
      <div class="col-12 mb-3">
          <label for="risk_result_notes" class="form-label">{{
            "inputs.risk_result_notes" | translate
            }}</label>
          <div class="input-group">
            <textarea class="form-control textarea100" id="risk_result_notes" rows="2" required
              formControlName="risk_result_notes"></textarea>
          </div>
      </div>
    </div>
</form>
